export default __webpack_public_path__ + "static/media/download.3cdf32ca.svg";